import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const modalRoot = document.createElement('div');
modalRoot.id = 'modal-root';
class Portal extends React.PureComponent {
  static propTypes = {
    children: PropTypes.array,
  };

  componentDidMount() {
    document.body.appendChild(modalRoot);
  }

  componentWillUnmount() {
    document.body.removeChild(modalRoot);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      modalRoot,
    );
  }
}

export default Portal;
